import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "468",
  height: "468",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "233.562",
      cy: "233.562",
      r: "232.808",
      stroke: "#cb99ff",
      "stroke-opacity": ".3",
      "stroke-width": "1.507"
    }, null, -1)
  ]))]))
}
export default { render: render }